(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const drawer = () => $('#cart-drawer');

  const open = () => {
    const d = drawer(); if (!d) return;
    d.dataset.open = 'true'; d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $('.drawer__close', d)?.focus();
  };
  const close = () => {
    const d = drawer(); if (!d) return;
    d.dataset.open = 'false'; d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  // Re-render the drawer through Shopify's Section Rendering API
  const refresh = async () => {
    const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('#cart-drawer');
    const d = drawer();
    if (!fresh || !d) return;
    $('.drawer__panel', d).innerHTML = $('.drawer__panel', fresh).innerHTML;
    document.querySelectorAll('[data-cart-count]').forEach(el => (el.textContent = fresh.dataset.count));
  };

  const change = async (key, quantity) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refresh();
  };

  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-close-cart]')) { close(); return; }
    const q = e.target.closest('[data-qty]');
    if (q) { change(q.dataset.key, Number(q.dataset.to)); return; }
    const t = e.target.closest('[data-thumb]');
    if (t) {
      const g = t.closest('[data-gallery]');
      const img = $('[data-main]', g);
      img.removeAttribute('srcset'); img.src = t.dataset.src; img.alt = t.dataset.alt || '';
      g.querySelectorAll('[data-thumb]').forEach(b => b.removeAttribute('aria-current'));
      t.setAttribute('aria-current', 'true');
    }
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-ajax]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('button[type=submit]');
    const err = f.querySelector('[data-error]');
    if (err) err.textContent = '';
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart.');
      await refresh(); open();
    } catch (x) {
      if (err) err.textContent = x.message;
    } finally {
      btn.disabled = false; btn.removeAttribute('aria-busy');
    }
  });
})();
